import { useQuery } from "@tanstack/react-query";
import { ExternalTravelCardRequestService } from "../../../../../services/company-office/ExternalTravelCardRequest";
import {
  getStatusBaseOnApprover,
  getStepBaseOnApprover,
} from "../../../info-technology-process/delete-user-account/utils";
import { transformRequestStatus } from "../../../utils";
import { useSelector } from "../../../../../store/store";

export const useExternalVehicleTravelCardRequests = () => {
  const user = useSelector((state) => state.user);
  const userEmail = user?.current?.username;

  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["external-vehicle-travel-card-requests"],
    queryFn: () => ExternalTravelCardRequestService.getExternalTravelCardRequests(userEmail),
  });

  const externalVehicleTravelCardMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === userEmail.toLowerCase()
  );

  const dataProcessed = data
    .map((record) => {
      const status = getStatusBaseOnApprover(record.fields, userEmail);
      const step = getStepBaseOnApprover(record.fields, userEmail);

      return {
        ...record.fields,
        id: record.id,
        createdByEmail: record.createdBy.user.email,
        createdByName: record.createdBy.user.displayName,
        createdDateTime: record.createdDateTime,
        eRequestStatus: transformRequestStatus(status, { step }),
      };
    })
    .sort((a, b) => b.id - a.id);

  const mappedExternalVehicleTravelCardRequests = dataProcessed
    .filter((record) => [record.eAssignee, record.eApprovedByITLead, record.eApprovedByITHead, record.eApprovedBy].some((approver) => approver?.toLowerCase().includes(userEmail.toLowerCase())))

  const mappedExternalVehicleTravelCardMyRequests = dataProcessed
    .filter((record) => record.createdByEmail.toLowerCase() === userEmail.toLowerCase())

  const guideLink = "https://drive.google.com/file/d/1Zz6B8Y_-wQU-ZiLHyhVll1_b9T3T_4bJ/view";

  return {
    ...restResponse,
    externalVehicleTravelCardRequests: data,
    externalVehicleTravelCardMyRequests,
    mappedExternalVehicleTravelCardRequests,
    mappedExternalVehicleTravelCardMyRequests,
    guideLink,
  };
};
